import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73371904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popupContent" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gPopwrap = _resolveComponent("gPopwrap")!

  return (_openBlock(), _createBlock(_component_gPopwrap, { pPopInfo: _ctx.mPopInfo }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", {
          innerHTML: _ctx.pAlertPopInfo.alertText
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["pPopInfo"]))
}